import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Invite } from '@/types/user';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  inviteId: string | number;
};

export const resendInvite = async (
  scope: RequestScope,
  { inviteId }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Invite>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Invite>>(`/organization/invite/resend/${inviteId}`, undefined, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
